export const PRODUCT_LAYOUTS = ['series', 'product'] as const;
export type ProductLayout = (typeof PRODUCT_LAYOUTS)[number];
